import { render } from "./EmailBtn.vue?vue&type=template&id=18924b63"
import script from "./EmailBtn.vue?vue&type=script&lang=js"
export * from "./EmailBtn.vue?vue&type=script&lang=js"

import exportComponent from "/srv/crewmaldives/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__